const menus = [
    {
        name: "menus.things_to_do",
        id: 1,
        children: [
            // {
            //     name: "What's On",
            //     link: "/whatson",
            // menu_id: 1
            // },
            {
                name: "menus.dining",
                link: "/dining",
                menu_id: 1
            },
            {
                name: "menus.services_facilities",
                link: "/services",
                menu_id: 1
            },
            {
                name: "menus.event_venue",
                link: "/event-venue",
                menu_id: 1
            },
        ],
    },
    {
        name: "menus.plan_your_visit",
        id: 2,
        children: [
            {
                name: "menus.getting_here",
                link: "/getting-here",
                menu_id: 2
            },
            {
                name: "menus.map",
                link: "/map",
                menu_id: 2
            },
            {
                name: "menus.tips",
                link: "/tips-on-wahoo",
                menu_id: 2
            },
           
            {
                name: "menus.plan_your_event",
                link: "/plan-your-event",
                menu_id: 2
            },
            {
                name: "menus.accomodation",
                link: "/accomodation",
                menu_id: 2
            },
            {
                name: "menus.term_and_condition",
                link: "/term-and-condition",
                menu_id: 2
            },
        ],
    },
    {
        name: "menus.ride_and_attractions",
        id: 3,
        children: [],
    },
    {
        name: "menus.tickets_and_packages",
        link: "/ticket-and-package",
        id: 4
    },
];

export default menus;